import template from './validationError.html';
import controller from './validationError.controller';
import './validationError.scss';

let validationErrorComponent = {
  restrict: 'E',
  bindings: {
    text: '<'
  },
  template,
  controller
};

export default validationErrorComponent;
